module.exports = __webpack_public_path__ + "img/画板 61.2bfb5234.svg";